import * as RadioGroup from '@radix-ui/react-radio-group'
import { ComponentProps, FC, forwardRef } from 'react'
import { styled } from '../../../config'

const Container = styled(RadioGroup.Root, {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  height: '100%',
  columnGap: '16px'
})

export const Root: FC<ComponentProps<typeof RadioGroup.Root>> = forwardRef(
  ({ children, ...props }, ref) => {
    return (
      <Container {...props} ref={ref}>
        {children}
      </Container>
    )
  }
)
